import React from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';
import logo from '../assets/logo_big.png'

const Navbar = ({ isLoggedIn, onLogout, username }) => {
  console.log("Test", username)
  return (
    <nav className="navbar">
      <img className='logo' src={logo}/>
      <h2>Pet Heaven</h2>
      <ul>
        <li><Link to="/">Home</Link></li>
        <li><Link to="/adoption">Adoption</Link></li>
        <li><Link to="/release-pet">Release Pet</Link></li>
        {/* <li><Link to="/aboutus">About Us</Link></li> */}
        {!isLoggedIn && <li><Link to="/login">Login</Link></li>}
        {!isLoggedIn && <li><Link to="/signup">Sign Up</Link></li>}
      </ul>
      {isLoggedIn && (
          <button onClick={onLogout} className="logout-button">Logout as {username}</button>
        )}
    </nav>
  );
};

export default Navbar;
